export enum Division
{
    CD  = 0,
    OEM = 1,
    RS = 2,
    PMAX = 3
}

export const DivisionMetadata = {
    '0': {
        display: 'Complete Door',
        value: 0
    },
    '1': {
        display: 'OEM',
        value: 1
    },
    '2': {
        display: 'Rolling Steel',
        value: 2
    },
    '3': {
        display: 'Performax',
        value: 3
    }
}